import * as React from "react";

const SvgIcnBellBold = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            d="M12.011 20.011c1.41 0 2.54-.773 2.86-2h3.402c.55 0 .893-.52.683-1.002l-.267-.577a18.124 18.124 0 01-1.677-7.349c0-2.845-2.187-5.083-5-5.083C9.2 4 7.026 6.236 7.026 9.1a18.181 18.181 0 01-1.692 7.33l-.268.576c-.223.454.138 1.005.682 1.005h3.403c.32 1.227 1.45 2 2.86 2z"
            fill="currentColor"
            fillRule="nonzero"
            stroke="none"
            strokeWidth={1}
        />
    </svg>
);

export default SvgIcnBellBold;
